import React from 'react';
import { timeline } from '../mock';
import { Circle, CheckCircle2 } from 'lucide-react';

const Timeline = () => {
  return (
    <section id="timeline" style={{
      minHeight: '100vh',
      padding: '160px 7.6923% 100px',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1000px',
        margin: '0 auto'
      }}>
        {/* Section header */}
        <div style={{ marginBottom: '80px', textAlign: 'center' }}>
          <div style={{
            fontFamily: 'monospace',
            fontSize: '14px',
            color: '#00FFD1',
            marginBottom: '16px',
            letterSpacing: '2px'
          }}>
            {'>> EVOLUTION PROTOCOL'}
          </div>
          <h2 style={{
            fontSize: '48px',
            fontWeight: 600,
            lineHeight: 1.1,
            color: '#FFFFFF',
            marginBottom: '24px'
          }}>
            Journey Timeline
          </h2>
        </div>

        {/* Timeline */}
        <div style={{ position: 'relative' }}>
          {/* Vertical line */}
          <div style={{
            position: 'absolute',
            left: '40px',
            top: '0',
            bottom: '0',
            width: '2px',
            background: 'linear-gradient(180deg, rgba(0, 255, 209, 0.6) 0%, rgba(0, 255, 209, 0.1) 100%)',
          }} />

          {/* Timeline items */}
          {timeline.map((item, index) => {
            const isCurrent = item.status === 'current';
            return (
              <div
                key={index}
                style={{
                  position: 'relative',
                  paddingLeft: '100px',
                  paddingBottom: index === timeline.length - 1 ? '0' : '80px'
                }}
              >
                {/* Icon */}
                <div style={{
                  position: 'absolute',
                  left: '29px',
                  top: '0',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#000000',
                  zIndex: 2
                }}>
                  {isCurrent ? (
                    <div style={{
                      width: '16px',
                      height: '16px',
                      background: '#00FFD1',
                      borderRadius: '50%',
                      boxShadow: '0 0 20px rgba(0, 255, 209, 0.8)',
                      animation: 'pulse 2s infinite'
                    }} />
                  ) : (
                    <CheckCircle2 size={24} style={{ color: '#00FFD1' }} />
                  )}
                </div>

                {/* Content card */}
                <div
                  style={{
                    background: isCurrent ? 'rgba(0, 255, 209, 0.08)' : 'rgba(255, 255, 255, 0.03)',
                    border: `1px solid ${isCurrent ? 'rgba(0, 255, 209, 0.4)' : 'rgba(0, 255, 209, 0.2)'}`,
                    padding: '32px',
                    transition: 'all 0.4s ease',
                    position: 'relative'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.border = '1px solid rgba(0, 255, 209, 0.6)';
                    e.currentTarget.style.background = 'rgba(0, 255, 209, 0.1)';
                    e.currentTarget.style.transform = 'translateX(8px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.border = `1px solid ${isCurrent ? 'rgba(0, 255, 209, 0.4)' : 'rgba(0, 255, 209, 0.2)'}`;
                    e.currentTarget.style.background = isCurrent ? 'rgba(0, 255, 209, 0.08)' : 'rgba(255, 255, 255, 0.03)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  {/* Year badge */}
                  <div style={{
                    display: 'inline-block',
                    padding: '6px 16px',
                    background: isCurrent ? '#00FFD1' : 'rgba(0, 255, 209, 0.2)',
                    color: isCurrent ? '#000000' : '#00FFD1',
                    fontSize: '14px',
                    fontWeight: 600,
                    fontFamily: 'monospace',
                    marginBottom: '16px',
                    letterSpacing: '1px'
                  }}>
                    {item.year}
                  </div>

                  {isCurrent && (
                    <div style={{
                      position: 'absolute',
                      top: '32px',
                      right: '32px',
                      padding: '4px 12px',
                      background: 'rgba(0, 255, 209, 0.2)',
                      border: '1px solid #00FFD1',
                      fontSize: '11px',
                      fontFamily: 'monospace',
                      color: '#00FFD1',
                      letterSpacing: '1px'
                    }}>
                      CURRENT
                    </div>
                  )}

                  <h3 style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    color: '#FFFFFF',
                    marginBottom: '12px',
                    fontFamily: 'monospace'
                  }}>
                    {item.title}
                  </h3>

                  <p style={{
                    fontSize: '16px',
                    lineHeight: 1.7,
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontFamily: 'monospace'
                  }}>
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom message */}
        <div style={{
          marginTop: '80px',
          textAlign: 'center',
          fontFamily: 'monospace',
          fontSize: '16px',
          color: 'rgba(255, 255, 255, 0.7)'
        }}>
          <span style={{ color: '#00FFD1', marginRight: '8px' }}>{'>'}</span>
          Evolution continues... More missions incoming
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.2);
          }
        }

        @media (max-width: 768px) {
          #timeline > div > div:nth-child(2) > div {
            padding-left: 80px !important;
          }
          #timeline > div > div:nth-child(2) > div > div:nth-child(1) {
            left: 29px !important;
          }
          #timeline > div > div:nth-child(2) > div:first-child {
            left: 20px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Timeline;